import { ObjectMapper } from 'json-object-mapper';
import { IModel } from './IModel';
import { Model } from './model';
import { ComptimeTacticalScreenConfig } from './corporate/insights/comptime-tactical-config.model';

export class InsightIndicatorParametersModel {
  analyticalEnabled: boolean | null = null;
  tacticalEnabled: boolean | null = null;
}

export class InsightsManagementParametersModel extends Model implements IModel<InsightsManagementParametersModel> {
  defaultKey: string = "";
  comptimeTacticalConfig: ComptimeTacticalScreenConfig | null = null;
  absenteism: InsightIndicatorParametersModel = new InsightIndicatorParametersModel();
  comptime: InsightIndicatorParametersModel = new InsightIndicatorParametersModel();

  static create(input: any): InsightsManagementParametersModel {
    return ObjectMapper.deserialize<InsightsManagementParametersModel>(InsightsManagementParametersModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
